import React from "react";

const FacebookShare = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.6429 0H2.35714C1.73199 0 1.13244 0.248341 0.690391 0.690391C0.248341 1.13244 0 1.73199 0 2.35714L0 19.6429C0 20.268 0.248341 20.8676 0.690391 21.3096C1.13244 21.7517 1.73199 22 2.35714 22H9.0971V14.5205H6.00335V11H9.0971V8.31679C9.0971 5.26478 10.9141 3.57893 13.697 3.57893C15.0297 3.57893 16.4234 3.81661 16.4234 3.81661V6.81214H14.8878C13.3748 6.81214 12.9029 7.75107 12.9029 8.71406V11H16.2805L15.7403 14.5205H12.9029V22H19.6429C20.268 22 20.8676 21.7517 21.3096 21.3096C21.7517 20.8676 22 20.268 22 19.6429V2.35714C22 1.73199 21.7517 1.13244 21.3096 0.690391C20.8676 0.248341 20.268 0 19.6429 0Z" fill="#0098F0"/>
</svg>
);

export default FacebookShare;
